/* eslint-disable */
export default {
  dialPlaceholder: 'Inserir nome ou número',
} as const;

// @key: @#@"dialPlaceholder"@#@ @source: @#@"Enter name or number"@#@
